// extracted by mini-css-extract-plugin
module.exports = {"user-profile-cell":"user-profile-cell__18YFd","profile-image":"profile-image__h9axb","m":"m__1CJkd","l":"l__TmgNL","name":"name__1UKQL"};